import countries from './countries'
import states from './states'
import cities from './cities'

const locations = {
    countries: Object.assign(countries, countries),
    states: Object.assign(states, states),
    cities: Object.assign(cities, cities),
}

export default locations